import { jsx as d } from "react/jsx-runtime";
import { useRef as L, useState as $, useEffect as b, useLayoutEffect as C } from "react";
import { u as P } from "./index-6a632112.mjs";
import { a as T, c as k, C as l } from "./createOptions-4792754a.mjs";
import { useWindowDimensions as D } from "./useWindowDimensions.js";
import { B as I } from "./themes-5f0b3c3d.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./lineHeights-72d3110c.mjs";
const { legendStrapStyle: B, tooltipStyles: O, legendLeftRightPositionStyle: j } = T({
  type: l.HEATMAP
}), q = P.div`
  ${({ legend: t }) => {
  if ((t?.indicatorShape === "strap" || t?.indicatorShape === void 0) && (t?.position === "bottom" || t?.position === "top"))
    return B;
}};
  ${O};
  ${j};
  ${({ $maxWidth: t }) => t && t < 600 && `
      max-width: ${t}px;
      overflow-x: auto;`};

  ${({ $isMobile: t }) => t && `
      max-width: 100%;
      overflow-x: auto;`};
`, U = (t) => {
  const {
    series: a,
    chartLibElement: u,
    xAxis: f,
    yAxis: g,
    legend: i,
    colorScaleRanges: w,
    hideLegendItems: n,
    height: s,
    width: p
  } = t, o = L(null), c = D().width, x = c < I.tabletMin, [W, S] = $(0);
  b(() => {
    const e = document.getElementById("heatmap-chart-wrapper")?.clientWidth;
    e && S(e);
  }, []), C(() => {
    o?.current?.chartRef?.current && n?.forEach((r) => {
      const e = o?.current?.chartRef?.current.querySelector(
        `div[seriesname="${r}"]`
      );
      e && e?.remove();
    });
  }, [n]);
  const h = (r) => {
    let e = 0;
    return r.forEach(({ data: H }) => {
      const m = H.length;
      m > e && (e = m);
    }), e;
  }, y = a.length * 50, E = h(a) * 60 + (c - h(a) * 60) - 50, A = w?.map(
    (r) => r?.name === null ? { ...r, name: " " } : r
  ), v = u, M = {
    markerWidth: "68.5px",
    markerHeight: "8px"
  }, R = k({
    type: l.HEATMAP,
    xAxis: f,
    yAxis: g,
    colorScaleRanges: A,
    legend: { ...M, ...i }
  });
  return /* @__PURE__ */ d(
    q,
    {
      legend: i,
      "data-testid": "heatmap-wrapper",
      id: "heatmap-chart-wrapper",
      $isMobile: x,
      $maxWidth: W,
      children: /* @__PURE__ */ d(
        v,
        {
          series: a,
          options: { ...R, responsive: [
            {
              breakpoint: 600,
              options: {
                chart: {
                  width: "600px"
                }
              }
            }
          ] },
          type: "heatmap",
          ref: o,
          height: s || y,
          width: p || E
        }
      )
    }
  );
};
export {
  U as HeatMapChart
};
